module.exports = __webpack_public_path__ + "img/banner3_4_en.c7212625.png";